'use client';

import { Headline } from "@/frontend/components/ui/headline";
import { ServiceElementComponent as ServiceElementComponentType } from "@/payload-types";
import { GridColumn, GridRow } from "@/frontend/components/ui/grid";
import { useRef } from "react";
import { useInView } from "motion/react";
import './styles.scss';
import clsx from "clsx";

interface TextTeaserGroupType {
  teaserElements: ServiceElementComponentType['teaserElements'];
};

export const TextTeaserGroup = ({ teaserElements }: TextTeaserGroupType) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const isInView = useInView(containerRef, {
    once: true,
    amount: 0.4,
  });

  return (
    <div className={clsx('service-teaser-group', { 'is-in-view': isInView})} ref={containerRef}>
      <GridRow>
        { teaserElements?.map((teaserElement, index) => {
          return (
            <GridColumn className="service-teaser-column" key={index} columnSize={{ xs: 12, m: 4 }}>
              <div className="service-teaser-element">
                <div className="teaser-content">
                  { teaserElement?.heading && <Headline as="h3">{teaserElement?.heading}</Headline> }
                  { teaserElement?.description && <p>{teaserElement?.description}</p> }
                  { teaserElement?.tags?.length ? (
                    <ul className="tags">
                      { teaserElement?.tags.map((tag, index) => (
                        <li className="tag" key={index}>{tag?.tag}</li>
                      ))}
                    </ul>
                  ): null}
                </div>
              </div>
            </GridColumn>
          )
        })}
      </GridRow>
    </div>
  );
};